{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           HBMWebData
    Folder:             C:\IONOS\TeamAGOGIK\trunk\HBMWeb\SRC\
    Created:            Sun 07.05.2023 21:45
    Author:             Michael Ellermann

    ShortDescription:   

    Description:        

**                                                                                                **
****************************************************************************************************
MnemoREM}
unit HBMWebData;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Modules,
  WEBLib.REST,
  WEBLib.Controls,

  PrjClassTokenInformation,
  PrjClassHBMDefaultData,
  PrjClassHBMDataAccess;

type
  TApplicationTyp = (atNone, atSpielleiter, atTeilnehmer, atAdministrator);

  TDataModule1 = class(TDataModule)
    WebHttpRequest1: THttpRequest;
    procedure WebDataModuleDestroy(Sender: TObject);
    procedure WebDataModuleCreate(Sender: TObject);
    procedure WebHttpRequest1Error(Sender: TObject; ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
    procedure WebHttpRequest1Timeout(Sender: TObject);
    procedure WebHttpRequest1Abort(Sender: TObject);
  private //-declarations
    FAktuellePeriode: Integer;
    FAktuellesUnternehmen: Integer;
    FDataAccess: TPrjClassHBMDataAccess;
    FHBMDefaultData: TPrjHBMDefaultData;
    FisSpielleiter: Boolean;
    FisTeilnehmer: Boolean;
    FisTransmitting: Boolean;
    FLetztePeriode: Integer;
    FLetztesUnternehmen: Integer;
    FSimulationName: string;
    FTokenInformation: TTokenInformation;
    function GetTokenInformation: TTokenInformation;
  public  //-declarations
  published
    property DataAccess: TPrjClassHBMDataAccess read FDataAccess write FDataAccess;
    property TokenInformation: TTokenInformation read GetTokenInformation;
    property HBMDefaultData: TPrjHBMDefaultData read FHBMDefaultData write FHBMDefaultData;
    property isSpielleiter: Boolean read FisSpielleiter write FisSpielleiter default false;
    property isTeilnehmer: Boolean read FisTeilnehmer write FisTeilnehmer default false;
    property isTransmitting: Boolean read FisTransmitting write FisTransmitting default false;
  protected procedure LoadDFMValues; override; end;

var
  DataModule: TDataModule1;

implementation

{%CLASSGROUP 'System.Classes.TPersistent'}

uses
  wxBaseClassWebTools,
  HBMWebDef;

{$R *.dfm}



procedure TDataModule1.WebDataModuleDestroy(Sender: TObject);
begin
  if Assigned(FDataAccess) then
  begin
    FreeAndNil(FDataAccess);
  end;
  if Assigned(FHBMDefaultData) then
  begin
    FreeAndNil(FHBMDefaultData);
  end;
  if Assigned(FTokenInformation) then
  begin
    FreeAndNil(FTokenInformation);
  end;
end;

procedure TDataModule1.WebDataModuleCreate(Sender: TObject);
begin
  if not Assigned(FDataAccess) then
  begin
    FDataAccess := TPrjClassHBMDataAccess.Create(self);
  end;
  if not Assigned(FHBMDefaultData) then
  begin
    FHBMDefaultData := TPrjHBMDefaultData.Create;
  end;
  if not Assigned(FTokenInformation) then
  begin
    FTokenInformation := TTokenInformation.Create;
  end;
end;

Procedure TDataModule1.WebHttpRequest1Abort(Sender: TObject);
begin
  wxBaseWriteLog.Write('HBMWebData::WebHttpRequest1 Abort: HTTP Request aborted', slError);
end;

procedure TDataModule1.WebHttpRequest1Error(Sender: TObject;  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
begin
  wxBaseWriteLog.Write('HBMWebData::WebHttpRequest1 Error: HTTP Request failed', slError);
end;

procedure TDataModule1.WebHttpRequest1Timeout(Sender: TObject);
begin
  wxBaseWriteLog.Write('HBMWebData::WebHttpRequest1 Timeout: Timeout occured', slDebug);
end;

function TDataModule1.GetTokenInformation: TTokenInformation;
begin
  if not Assigned(FTokenInformation) then
  begin
    FTokenInformation := DataModule.TokenInformation.Create;
  end;
  Result := FTokenInformation;
end;


procedure TDataModule1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebHttpRequest1 := THttpRequest.Create(Self);

  WebHttpRequest1.BeforeLoadDFMValues;
  try
    Name := 'DataModule1';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    SetEvent(Self, 'OnDestroy', 'WebDataModuleDestroy');
    Height := 653;
    Width := 934;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    SetEvent(WebHttpRequest1, Self, 'OnAbort', 'WebHttpRequest1Abort');
    SetEvent(WebHttpRequest1, Self, 'OnError', 'WebHttpRequest1Error');
    SetEvent(WebHttpRequest1, Self, 'OnTimeout', 'WebHttpRequest1Timeout');
    WebHttpRequest1.Left := 248;
    WebHttpRequest1.Top := 136;
  finally
    WebHttpRequest1.AfterLoadDFMValues;
  end;
end;

end.
